import { combineReducers, configureStore } from '@reduxjs/toolkit';
import programReducer from './slices/programSlice';
import userInformationReducer from './slices/userInformationSlice';

const reducer = combineReducers({
  program: programReducer,
  userInformation: userInformationReducer,
});

export const createStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer,
    preloadedState,
  });

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof reducer>;
export type AppDispatch = ReturnType<typeof createStore>['dispatch'];

export const store = createStore();
export default createStore;
